module.exports = __webpack_public_path__ + "img/backgroundtest.cbbf173b.png";